<template>
	<v-container fluid class="pa-0 d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<OnlyOfficeEditor :documentId="documentId" :height="$store.getters['general/availableHeight']+'px'" :mode="'edit'" />
	</v-container>
</template>

<script>
import OnlyOfficeEditor from '@/components/Helpers/Editor/OnlyOfficeEditor';

export default {
	name: "OnlyOfficeFullEditor",
	components: {
		OnlyOfficeEditor,
	},
	computed: {
		documentId() {
			return this.$route.params.id;
		},
	},
  data() {
    return {};
  },
};
</script>